/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-01 14:49:34
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-10 17:48:30
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\chaining\api\index.js
 */
import request from '@/utils/req.js';

//模板链 模块  模板方案 和模板广场接口
export function apiGetSchemePage(params) {
    return request.get("/admin/scheme/page", params)
}
//模板链列表
export function apiGetSchemeMy(params) {
    return request.get("/admin/scheme/my", params)
}

//模板链项目添加   药物治疗功能训练等...
export function apiPostSchemeItem(params) {
    return request.post("/admin/scheme-item", params)
}
//模板链 模板广场 模板复制
export function apiPostSchemeCopy(params,a) {
    return request.post(`/admin/scheme/copy?id=${params}&schemeType=${a}`)
}

// 医生链 模板广场 模板广场引用
export function apiPostSchemeQuote(params) {
    return request.post(`/admin/scheme/quote?id=${params}`)
}

//模板链 模板禁用
export function apiPostSchemeDisable(params,a) {
    return request.post(`/admin/scheme/disable?id=${params}&schemeType=${a}`)
}
//模板链 模板启用
export function apiPostSchemeEnable(params,a) {
    return request.post(`/admin/scheme/enable?id=${params}&schemeType=${a}`)
}
//模板链 模板删除
export function apiPostSchemeDelete(params,a) {
    return request.delete(`/admin/scheme/delete?id=${params}&schemeType=${a}`)
}

//宣教列表分页查询
export function api_get_mission(params) {
    return request.post("/admin/mission/page",params);
}

//疾病类型获取
export function api_get_disease_type(params) {
    return request.get("/admin/disease-type",params);
}
//保存方案基本信息 ，权益
export function api_post_admin_scheme(params) {
    return request.post("/admin/scheme",params);
}
//编辑方案基本信息 ，权益
export function api_putschemeinfo(params) {
    return request.put("/admin/scheme/",params);
}
//根据方案ID 获取方案详情
export function api_getschemeinfo(params,a) {
    return request.get(`/admin/scheme/detail?id=${params}&schemeType=${a}`);
}


// 获取模板链推送消息列表
export function api_post_admin_scheme_messages_list(params) {
    return request.post("/admin/scheme-messages/list",params);
}

// 服务号推送--添加提醒设置
export function api_post_admin_scheme_messages(params) {
    return request.post("/admin/scheme-messages",params);
}

// 编辑 更新
export function api_Put_Scheme_Message(params) {
    return request.put("/admin/scheme-messages",params);
}

// 服务号推送--模板链删除 /admin/scheme-message/{id}
export function apiPostSchemeMessageDelete(params) {
    return request.delete(`/admin/scheme-messages/delete?id=${params.id}&schemeType=${params.schemeType}`)
}

//新增方案   药物治疗  药品查询
export function api_getdrug(params) {
    return request.post("/admin/drug-new/page",params);
}
//新增方案链
export function api_addSchemeItem(params) {
    return request.post("/admin/scheme-item",params);
}
//功能训练 培训教程查询
export function api_get_train_course(params) {
    return request.get("/admin/train-course",params);
}
//功能训练
export function api_get_train_chapter(params) {
    return request.get("/admin/train-chapter/",params);
}
//获取运动分类
export function api_standard_list(params) {
    return request.post("/admin/standard-category/list",params);
}
//根据运动分类获取项目
export function api_movement_info_list(params) {
    return request.post("/admin/movement-info/list",params);
}
//跟新项目接口
export function api_Put_Scheme_Item(params) {
    return request.put("/admin/scheme-item",params);
}
//获取医生链我的方案列表接口
export function api_doctor_scheme_list(params) {
    return request.get("/admin/doctor-scheme/my",params);
}
export function api_Scheme_My(params) {
    return request.get("/admin/scheme/my",params);
}
//患者链列表
export function api_patient_scheme(params) {
    return request.get("/admin/patient-scheme/page",params);
}
//管理方案模型，查询问卷接口
export function api_get_oss_surveys(params) {
    return request.post("/admin/qs-exam-paper/page",params);
}
//提交审核
export function api_getschemeCommit(b,a) {
    return request.put(`/admin/scheme/commit?schemeId=${b}&schemeType=${a}`);
}
//模板链提交审核
export function api_tempSchemeCommit(params) {
  // return request.put(`/admin/scheme/commit?schemeId=${b}&schemeType=${a}`);
  return request.put("/admin/scheme/commit",params);
}
//模板链审核分页查询
export function api_scheme_approve_page(params) {
    return request.post("/admin/scheme-approve/page",params);
}
//模板链审核详情
export function api_scheme_approve(params) {
    return request.get(`/admin/scheme-approve/${params}`);
}
//审核驳回
export function api_scheme_approve_reject(params) {
    return request.post("/admin/scheme-approve/reject",params);
}
//模板链审核通过
export function api_scheme_approve_accept(params) {
  return request.post(`/admin/scheme-approve/accept?id=${params}`);
}


//审核通过
export function api_scheme_approve_pass(params) {
    return request.post(`/admin/scheme-approve/pass?id=${params}`);
}

// 获取方案归属列表 /admin/doctor-team-member/getLeaderListByJoinedTeam
export function getLeaderListByJoinedTeam(params) {
    return request.get(`/admin/doctor-team-member/getLeaderListByJoinedTeam`, params);
}

//报告处理展示问卷
export function selectListExam(params) {
  return request.get("/admin/qs-answer-sheet/getAnswerSheetLog", params)
}

// 患者逻辑树（消息）列表查询
export function getPatientSchemeDecisionList(params) {
    return request.post(`/admin/patient-scheme-decision-tree/listByPatientSchemeId`, params);
}

// 医生链逻辑树列表
export function getDoctorSchemeDecisionList(params) {
    return request.post(`/admin/doctor-scheme-decision-tree/listByDoctorSchemeId`, params);
}

// 模板链逻辑树列表
export function getSchemeDecisionList(params) {
    return request.post(`/admin/scheme-decision-tree/listBySchemeId`, params);
}

// 逻辑树列表查询（新增）
export function getDecisionList(params) {
    return request.post(`/admin/decision-tree/list`, params);
}

// 医生链与逻辑树关系添加
export function doctorDecisionAdd(params) {
    return request.post(`/admin/doctor-scheme-decision-tree`, params);
}

// 患者链与逻辑树关系添加
export function patientDecisionAdd(params) {
    return request.post(`/admin/patient-scheme-decision-tree`, params);
}

// 模板链与逻辑树关系添加
export function schemeDecisionAdd(params) {
    return request.post(`/admin/scheme-decision-tree`, params);
}

// 医生链与逻辑树关系删除
export function doctorDecisionDelete(id) {
    return request.delete(`/admin/doctor-scheme-decision-tree/${id}`);
}

// 患者链与逻辑树关系删除
export function patientDecisionDelete(id) {
    return request.delete(`/admin/patient-scheme-decision-tree/${id}`);
}

// 模板链与逻辑树关系删除
export function schemeDecisionDelete(id) {
    return request.delete(`/admin/scheme-decision-tree/${id}`);
}

// 点已知清空患者链提醒
export function patientschemeClearNoti(id) {
    return request.put(`/admin/patient-scheme/clearNoti/${id}`);
}

// 逻辑信息模糊搜索信息
export function getSearchPartInfo(params) {
    return request.post(`/admin/decision-tree/searchPartInfo`, params);
}

// 添加至方案
export function getAddTemplate(params) {
    return request.post(`/admin/doctor-scheme/addToDoctorScheme?schemeId=${params}`);
}

//获取战略病种列表
export function getStrategicDiseaseAndWechat(params) {
  return request.get("/admin/disease-type/getStrategicDiseaseAndWechat", params)
}

//获取所有疗管链
export function getAllTherapistScheme(params) {
  return request.post("/admin/scheme/getAllTherapistScheme", params)
}

//获取战略病种治疗阶段
export function getTherapyStageByDiseaseId(params) {
  return request.get("/admin/disease-following/getTherapyStageByDiseaseId", params)
}


//获取随手记小工具
export function getPatientRecordByDiseaseId(params) {
    return request.get("/admin/disease-patient-record/getPatientRecordByDiseaseId", params)
}



